export default "__VITE_ASSET__BalUwgJv__"